<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/i8Q7bC/tc-custom/9781504069465.jpg?1706964433240" alt="This image is the cover for the book Deep Dark Secrets"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Deep Dark Secrets
      </h1>
      <p class="bookDescription body article font2">
        <b>In this thriller by the bestselling author of <i>D for Dead</i>, a woman is terrorised after returning to the town where she was almost murdered eighteen years ago.</b><br/><br/><i>The darkest minds hide the deepest secrets . . .</i><br/><br/> Lizzie Kent wasn’t supposed to babysit the night she was murdered. She was covering for her best friend, Nell. Nell has lived with the guilt ever since.<br/><br/> Eighteen years later Nell returns to the area, desperate to escape a bad relationship after inheriting her aunt’s rundown guesthouse. But her return isn’t welcomed by everyone—in particular Sam Kent, who blames Nell for his sister’s death. And after a few unsettling incidents, it becomes apparent that someone is trying to scare her.<br/><br/> Is Sam responsible or has Nell’s abusive ex-boyfriend managed to track her down? Or is someone else, with a more sinister agenda, responsible?<br/><br/><b>Previously published as <i>The Darkness Beneath.</i></b><br/><br/><b><i>Deep Dark Secrets</i> is an astonishing psychological thriller that will appeal to fans of authors like Clare Mackintosh, Cara Hunter, and Paula Hawkins.</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Keri Beevis
      </h2>
      
      <p class="authorDescription body article">Keri Beevis wrote her first novel at age twenty, but it was a further twenty years before she was published after winning a contract in the Rethink Press New Novels Competition 2012.   Born in the village of Old Catton, less than a mile from where Anna Sewell was living when she wrote Black Beauty, Keri had a passion for reading and writing from a young age, though her tastes veered more to the macabre.   Today she still lives in Norwich, along with her two naughty kitties, Ellie and Lola, and a plentiful supply of red wine (her writing fuel), where she writes a comedic lifestyle column for a local magazine. She loves Hitchcock movies, exploring creepy places, and gets extremely competitive in local pub quizzes. She is also a self-confessed klutz.  Keri joined the Bloodhound team in 2019 and her first release with them, the psychological thriller, Dying To Tell, which is set in her beautiful home county of Norfolk, has been her biggest success to date, with over 1200 four and five star ratings on Goodreads.   She is now looking forward to the relaunch of her three earlier novels in 2020.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d479337e